import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRegion } from "@/hooks/useRegion";
import { isAdminShellPath } from "@/lib/geoConsentRoutes";

export const RegionProvider = ({ children }: { children: React.ReactNode }) => {
  const { region } = useRegion();
  const { pathname } = useLocation();

  useEffect(() => {
    if (isAdminShellPath(pathname)) {
      document.body.removeAttribute("data-region");
      document.documentElement.removeAttribute("data-region");
      return;
    }
    // Add region class to body for CSS targeting
    document.body.setAttribute("data-region", region);
    document.documentElement.setAttribute("data-region", region);

    return () => {
      document.body.removeAttribute("data-region");
      document.documentElement.removeAttribute("data-region");
    };
  }, [region, pathname]);

  return <>{children}</>;
};
